import { Check, MessageCircle } from 'lucide-react'
import { Empty, Row, Sheet } from '../../ui'
import { listedThreads, threadTitle } from '../../lib/chatClient'
import { Failed } from '../../screens/Stub'
import { fmtDayShort } from '../../lib/today'
import type { ChatThread } from '../../lib/chat'

const when = fmtDayShort

/**
 * Every thread, most recent first: its title and the day it was last used.
 * Tap to open one; the one on screen is ticked. Old threads are kept and
 * listable, never resent (README, *Decisions*).
 */
export function ThreadsSheet({ open, threads, error, current, onPick, onClose }: {
  open: boolean
  threads: ChatThread[]
  /** a2-04 — the list could not be read: said so, ahead of "No threads
   *  yet", which would otherwise claim there are none. */
  error: Error | null
  current: string | null
  onPick: (id: string) => void
  onClose: () => void
}) {
  const shown = listedThreads(threads)
  return (
    <Sheet open={open} onOpenChange={o => { if (!o) onClose() }} title="Threads">
      {error ? (
        <Failed error={error.message} />
      ) : shown.length === 0 ? (
        <Empty title="No threads yet" />
      ) : (
        <div className="chat-threads">
          {shown.map(t => (
            <Row
              key={t.id}
              className="u-row--list"
              leading={<MessageCircle size={18} aria-hidden="true" />}
              title={threadTitle(t.title, null) ?? 'Untitled'}
              meta={when(t.last_at)}
              trailing={t.id === current ? <Check size={18} aria-label="Open now" /> : null}
              aria-current={t.id === current ? 'true' : undefined}
              onPress={() => onPick(t.id)}
            />
          ))}
        </div>
      )}
    </Sheet>
  )
}
